(function() {
    'use strict';

    angular.module("imApp").factory("consignmentDeliveryActivityService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1979,
                    parameters: parms || {}
                });
            },
            listDeliveryActivities: function (parms) {
                return $ihttp.post({
                    method: 1977,
                    parameters: parms || {}
                });
            },
            confirm: function (setting) {
                return $ihttp.post({
                    method: 261,
                    parameters: setting
                });
            }
        }

        return service;
    }]);
})();
